/**
 * 收藏（自己写的，2026-08-29 换掉 Wishlist by Square 应用）
 *
 * 为什么自己写：May 的原话「购物车和收藏分属不同出处，所以让他们一致就比较麻烦」。
 * 应用那颗角标我看不到也改不了，照截图猜了四版还是对不齐 —— 那是结构问题。
 * 现在两颗角标共用同一个 `.cart-count-bubble`，不可能再不一致。
 *
 * ── 三条设计纪律，改之前先看 ──────────────────────────────
 *
 * ① 顶栏的数字【不在这个文件里】首次渲染。
 *    它由 header.liquid 里那段同步内联脚本在首次绘制前写好。
 *    这个文件只负责「点了之后更新」。
 *    ⚠️ 不要把首次渲染挪到这里来 —— 这个文件是 defer 的，
 *       挪过来就会出现「先看到没数字的心、再跳出数字」，
 *       那正是换掉应用要解决的问题。
 *
 * ② 存的是【商品 handle】不是 variant id。
 *    收藏是「记住这一款」，不是「记住这个尺码」——
 *    存 variant 的话她改一次变体，买家的收藏就指向不存在的东西了。
 *
 * ③ 所有写操作都走 save()，所有读都走 load()。
 *    以后要改成跟着账号走（客户元字段 / App Proxy），只改这两个函数，
 *    其余代码一行都不用动。
 */
(function () {
  /**
   * ⚠️ 这一行是「没有 JS 就不显示收藏按钮」的**唯一**执行点。
   * 一个点了没反应的爱心比没有爱心更糟。
   *
   * ⚠️ 不能用 Dawn 惯例的 `.js` / `.no-js` —— 这个主题的 <html> 上
   *    **写死了 class="js"**（layout/theme.liquid 第 2 行），
   *    不管脚本跑没跑它都在，用它判断等于没判断（我 2026-08-29 就这么写错过一次）。
   * ⚠️ 也不能用 `.no-js-hidden` —— 那个类这个主题里**根本没有定义**，挂了没有任何效果。
   * 所以这里自己打一个只有脚本真的跑起来才会有的标记。
   */
  document.documentElement.classList.add('torena-wish-on');

  var KEY = 'torena-wishlist';
  var MAX = 500; // 上限。localStorage 一般 5MB，但没上限的列表迟早会有人玩坏

  function load() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function save(arr) {
    try {
      localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX)));
    } catch (e) {
      /* 隐私模式 / 存储满了：静默失败。收藏不是关键路径，不该弹错打断她的买家 */
    }
  }

  function paintCount() {
    var n = load().length;
    document.querySelectorAll('[data-torena-wish-count]').forEach(function (b) {
      b.hidden = n === 0;
      if (n) b.firstElementChild.textContent = n > 999 ? '999+' : String(n);
    });
  }

  /** 把页面上所有收藏按钮的「已收藏 / 未收藏」状态刷一遍 */
  function paintButtons() {
    var set = load();
    document.querySelectorAll('[data-torena-wish]').forEach(function (btn) {
      var on = set.indexOf(btn.getAttribute('data-torena-wish')) !== -1;
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.getAttribute(on ? 'data-label-on' : 'data-label-off');
      if (label) btn.setAttribute('aria-label', label);
    });
  }

  function toggle(handle) {
    var arr = load();
    var i = arr.indexOf(handle);
    if (i === -1) arr.unshift(handle); // 新收的排最前，收藏页按收藏顺序倒序看着自然
    else arr.splice(i, 1);
    save(arr);
    paintCount();
    paintButtons();
    // 收藏页要跟着变（同一个页面里删掉一张卡）
    document.dispatchEvent(new CustomEvent('torena:wishlist-changed', { detail: { handle: handle, list: arr } }));
  }

  /**
   * ⚠️ 用事件委托，不是给每个按钮单独绑。
   * 产品卡是会被替换掉的（筛选、翻页、快速加购弹窗都会重渲染一片 DOM），
   * 单独绑的监听器一换就没了 —— 表现是「筛选之后爱心点不动」。
   */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-torena-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation(); // 卡片整张是个链接，不阻止的话点爱心会跳进商品页
    toggle(btn.getAttribute('data-torena-wish'));
  });

  // 别的标签页里改了收藏，这个页面也跟着变
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { paintCount(); paintButtons(); }
  });

  // 产品卡被重新渲染之后要重新上色（筛选/翻页/快速加购都会触发）
  var mo = new MutationObserver(function () { paintButtons(); });

  function start() {
    paintCount();
    paintButtons();
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // 收藏页要用到读取和删除，挂出去
  window.TorenaWishlist = { load: load, toggle: toggle, KEY: KEY };
})();
